import { sendSocketMessage, socketMessageStream } from "../utils/socketStream";
import { filter, map } from "rxjs/operators";
import auth from "../store/modules/auth";
import site from "../store/modules/site";
import { publishMessage } from "../utils/systemPubSub";
import log2 from "../utils/log2";

const store = require("@/store").default;

const conversations = {};
export const getVideoCall = (number) => conversations[number];
const log = log2("phonesdk");
export const PHONE = (window.PHONE = (config) => {
    const socketMessagePrefix = "user ";
    const PHONE = () => {};
    const autocam = config.autocam === true;
    const sessionid = config.userId || auth.state.user._id;
    const myNumber = sessionid;
    config.number = myNumber;
    let mediaconf = config.media || {
        audio: true,
        video: { facingMode: "user" },
    };
    let camStarted = false;
    let myvideo = document.createElement("video");
    myvideo.id = "me";
    let snapper = () => " ";
    let mystream = null;
    let myconnection = false;
    const senders = {};
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // RTC Peer Connection Session (one per call)
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    const PeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // ICE (many route options per call)
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    const IceCandidate = window.RTCIceCandidate || window.mozRTCIceCandidate;

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Media Session Description (offer and answer per call)
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    const SessionDescription =
        window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription;

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // STUN Server List Configuration (public STUN list)
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    const rtcconfig = {
        iceServers: [
            {
                urls: navigator.mozGetUserMedia
                    ? "stun:stun.services.mozilla.com"
                    : navigator.webkitGetUserMedia
                    ? "stun:stun.l.google.com:19302"
                    : "stun:23.21.150.121",
            },
            //{urls: "stun:stun.l.google.com:19302"},
            { urls: "stun:stun1.l.google.com:19302" },
            { urls: "stun:stun2.l.google.com:19302" },
            { urls: "stun:stun3.l.google.com:19302" },
            //{urls: "stun:stun4.l.google.com:19302"},
            //{urls: "stun:23.21.150.121"},
            //{urls: "stun:stun01.sipphone.com"},
            //{urls: "stun:stun.ekiga.net"},
            //{urls: "stun:stun.fwdnet.net"},
            //{urls: "stun:stun.ideasip.com"},
            //{urls: "stun:stun.iptel.org"},
            //{urls: "stun:stun.rixtelecom.se"},
            //{urls: "stun:stun.schlund.de"},
            //{urls: "stun:stunserver.org"},
            //{urls: "stun:stun.softjoys.com"},
            //{urls: "stun:stun.voiparound.com"},
            //{urls: "stun:stun.voipbuster.com"},
            //{urls: "stun:stun.voipstunt.com"},
            //{urls: "stun:stun.voxgratia.org"},
            //{urls: "stun:stun.xten.com"}
        ],
        iceTransportPolicy: "all",
        iceCandidatePoolSize: "0",
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Custom STUN Options
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function add_servers(servers) {
        if (servers.constructor === Array) [].unshift.apply(rtcconfig.iceServers, servers);
        else rtcconfig.iceServers.unshift(servers);
    }

    if ("servers" in config) add_servers(config.servers);

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // PHONE Events
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    let messagecb = () => {};
    let readycb = () => {};
    let cameracb = () => {};
    let unablecb = () => {};
    let debugcb = (a, b) => {
        //console.log('phonesdk', a, b)
    };
    let connectcb = () => {};
    let disconnectcb = () => {};
    let reconnectcb = () => {};
    let callstatuscb = () => {};
    let receivercb = () => {};

    PHONE.camera = (cb) => (cameracb = cb);
    PHONE.message = (cb) => (messagecb = cb);
    PHONE.ready = (cb) => (readycb = cb);
    PHONE.unable = (cb) => (unablecb = cb);
    PHONE.callstatus = (cb) => (callstatuscb = cb);
    PHONE.debug = (cb) => (debugcb = cb);
    PHONE.connect = (cb) => (connectcb = cb);
    PHONE.disconnect = (cb) => (disconnectcb = cb);
    PHONE.reconnect = (cb) => (reconnectcb = cb);
    PHONE.receive = (cb) => (receivercb = cb);
    PHONE.conversations = conversations;
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Add/Get Conversation - Creates a new PC or Returns Existing PC
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function get_conversation(number) {
        let talk =
            conversations[number] ||
            ((number) => {
                let talk = {
                    number: number,
                    status: "",
                    image: document.createElement("img"),
                    started: +new Date(),
                    imgset: false,
                    imgsent: 0,
                    pc: new PeerConnection(rtcconfig),
                    closed: false,
                    usermsg: () => {},
                    thumb: null,
                    connect: () => {},
                    end: () => {},
                };

                // Setup Event Methods
                talk.pc.ontrack =
                    config.ontrack ||
                    function (event) {
                        onaddstream(number, event);
                    };

                talk.pc.onicecandidate = function (event) {
                    onicecandidate(number, event);
                };
                talk.pc.onnegotiationneeded = (event) => {
                    log("onnegotiationneeded called", number);
                    log("createOffer running onnegotiationneeded", number);
                    // talk.pc.createOffer().then(offer=>{
                    //     log('createOffer success onnegotiationneeded', number)
                    //     talk.pc.setLocalDescription(offer).then(() => {
                    //         log('setLocalDescription success onnegotiationneeded', number)
                    //         transmit(number, offer)
                    //     }).catch((e) => {
                    //         log.error('onnegotiationneeded setLocalDescription error', e)
                    //     })
                    // }).catch(e=>{
                    //     log.error('onnegotiationneeded createOffer error', e)
                    // })
                };
                talk.pc.number = number;

                // Disconnect and Hangup
                talk.hangup = (signal) => {
                    log("hangup", talk);
                    publishMessage("vc_ended", {});
                    if (talk.closed) return;

                    talk.closed = true;
                    talk.imgset = false;

                    if (signal !== false) transmit(number, { hangup: true });

                    talk.end(talk);
                    talk.pc.close();
                    close_conversation(number);
                };

                // Disconnected?
                talk.pc.oniceconnectionstatechange = function () {
                    log("oniceconnectionstatechange", talk.pc.iceConnectionState);
                    if (talk.pc.iceConnectionState == "disconnected") {
                        log.warn("iceConnectionState disconnected hangup calling", number);
                        talk.hangup();
                    }
                };

                // Stop Audio/Video Stream
                talk.stop = () => {
                    log("stop", talk);
                    if (mystream) stopcamera();
                    return mystream;
                };

                // Sending Messages
                talk.send = (message) => {
                    transmit(number, { usermsg: message });
                };

                // Sending Stanpshots
                talk.snap = () => {
                    return;
                    let pic = snapper();
                    transmit(number, { thumbnail: pic });
                    let img = document.createElement("img");
                    img.src = pic;
                    return { data: pic, image: img };
                };

                // Take One Snapshot
                talk.snap();

                // Nice Accessor to Update Disconnect & Establis CBs
                talk.thumbnail = (cb) => {
                    talk.thumb = cb;
                    return talk;
                };
                talk.ended = (cb) => {
                    talk.end = cb;
                    return talk;
                };
                talk.connected = (cb) => {
                    log("connected", talk);
                    talk.connect = cb;
                    return talk;
                };
                talk.message = (cb) => {
                    talk.usermsg = cb;
                    return talk;
                };

                // Add Local Media Streams Audio Video Mic Camera
                if (mystream)
                    mystream.getTracks().forEach((track) => {
                        const sender = talk.pc.addTrack(track, mystream);
                        //senders[track.kind] = sender
                        log("addTrack->", track, sender);
                    });

                // Notify of Call Status
                update_conversation(talk, "connecting");

                // Return Brand New Talk Reference
                conversations[number] = talk;
                return talk;
            })(number);

        // Return Existing or New Reference to Caller
        return talk;
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Remove Conversation
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function close_conversation(number) {
        conversations[number] = null;
        delete conversations[number];
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Notify of Call Status Events
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function update_conversation(talk, status) {
        talk.status = status;
        callstatuscb(talk);
        return talk;
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // DOM Bind
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.bind = (type, el, fun) => {
        type.split(",").forEach((etype) => {
            const rapfun = (e) => {
                if (!e) e = window.event;
                if (!fun(e)) {
                    e.cancelBubble = true;
                    e.preventDefault && e.preventDefault();
                    e.stopPropagation && e.stopPropagation();
                }
            };

            if (el.addEventListener) el.addEventListener(etype, rapfun, false);
            else if (el.attachEvent) el.attachEvent("on" + etype, rapfun);
            else el["on" + etype] = rapfun;
        });
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // DOM UNBind
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.unbind = (type, el, fun) => {
        if (el.removeEventListener) el.removeEventListener(type, false);
        else if (el.detachEvent) el.detachEvent("on" + type, false);
        else el["on" + type] = null;
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Get Number
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.number = () => {
        return myNumber;
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Get Call History
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.history = (settings) => {
        console.warn("TODO not implemented");
        // pubnub.history({
        //     channel  : settings[number],
        //     callback : call_history => {
        //         settings['history'](call_history[0]);
        //     }
        // })
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Make Call - Create new PeerConnection
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.dial = function (number, servers) {
        if (!!servers) add_servers(servers);
        if (!number) return debugcb("Missing Number to Dial.");

        let talk = get_conversation(number);

        let pc = talk.pc;

        // Prevent Repeat Calls
        if (talk.dialed) return false;
        talk.dialed = true;
        store.dispatch("app/setVideoCall", number);
        // Send SDP Offer (Call)
        pc.createOffer()
            .then(async (offer) => {
                pc.setLocalDescription(offer)
                    .then(() => {
                        log("setLocalDescription success");
                        transmit(number, offer);
                    })
                    .catch((e) => {
                        log.error("setLocalDescription error", e);
                    });
            })
            .catch((error) => log.error("createOffer error", error));

        // Return Session Reference
        return talk;
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Send Image Snap - Send Image Snap to All Calls or a Specific Call
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.snap = function (message, number) {
        if (number) return get_conversation(number).snap(message);
        let pic = {};
        for (let number in conversations) pic = conversations[number].snap();
        return pic;
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Send Message - Send Message to All Calls or a Specific Call
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.send = (message, number) => {
        if (number) return get_conversation(number).send(message);
        for (let number in conversations) conversations[number].send(message);
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // End Call - Close All Calls or a Specific Call
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.hangup = (number) => {
        if (number) return get_conversation(number).hangup();
        for (let number in conversations) conversations[number].hangup();
    };

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Auto-hangup on Leave
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.bind("unload,beforeunload", window, (e) => {
        log("unload called", PHONE.goodbye);
        if (PHONE.goodbye) return true;
        PHONE.goodbye = true;

        for (let number in conversations) {
            let talk = conversations[number];
            let mynumber = config.number;
            let packet = { hangup: true };
            let message = { packet: packet, id: sessionid, number: mynumber };
            sendSocketMessage(socketMessagePrefix + "webrtc", message);
            talk.hangup();
        }

        if (e) e.returnValue = undefined;
        return undefined;
    });

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Grab Local Video Snapshot
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function snapshots_setup(stream) {
        let video = myvideo || document.createElement("video");
        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");
        let snap = { width: 240, height: 180 };

        // Video Settings
        video.width = snap.width;
        video.height = snap.height;
        video.volume = 0.0;

        // Start Video Stream
        try {
            video.srcObject = stream;
            video.play();
        } catch (e) {
            debugcb(["video.play(FAIL)", e]);
        }

        // Canvas Settings
        canvas.width = snap.width;
        canvas.height = snap.height;

        // Capture Local Pic
        snapper = () => {
            try {
                context.drawImage(video, 0, 0, snap.width, snap.height);
            } catch (e) {
                debugcb(["context.drawImage(FAIL)", e]);
            }
            return canvas.toDataURL("image/jpeg", 0.3);
        };
    }

    function isScreenStream(number, stream) {
        let talk = get_conversation(number);
        const remoteStreams = talk.pc.getRemoteStreams();
        const streamMetas = remoteStreams.reduce((acc, cur) => {
            acc[cur.id] = {
                stream: cur,
                isScreen: cur.getTracks().length === 1,
                label: cur.label,
            };
            return acc;
        }, {});
        const meta = streamMetas[stream.id];
        return !!meta && meta.isScreen;
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Visually Display New Stream
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function onaddstream(number, obj) {
        log("onaddstream", number, obj);
        const stream = obj.streams[0];
        changeRemoteVideo(number, stream);
        log("isScreenStream", stream, isScreenStream(number, stream));
        if (isScreenStream(number, stream)) {
            stream.onremovetrack = ({ track }) => {
                log("screen onremovetrack called");
                log(`${track.kind} track was removed.`);
                if (!stream.getTracks().length) {
                    log(`stream ${stream.id} emptied (effectively removed).`);
                    let talk = get_conversation(number);
                    const streams = talk.pc.getRemoteStreams();
                    if (streams[0]) {
                        changeRemoteVideo(number, streams[0]);
                    }
                }
            };
        }
        publishMessage("videocall-success", true);
    }

    function changeRemoteVideo(number, stream) {
        let vid = document.createElement("video");
        let talk = get_conversation(number);

        vid.setAttribute("autoplay", "autoplay");
        vid.setAttribute("playsinline", "playsinline");
        vid.srcObject = stream;
        vid.id = "other";
        talk.video = vid;
        conversations[number] = talk;
        log("conversations updated", conversations, talk);
        talk.connect(talk);
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // On ICE Route Candidate Discovery
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function onicecandidate(number, event) {
        if (!event.candidate) return;
        transmit(number, event.candidate);
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Listen For New Incoming Calls
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function dailer_subscribe() {
        onready(true);
        socketMessageStream
            .pipe(
                filter((x) => x.cmd === "webrtc"),
                map((x) => x.data)
            )
            .subscribe((data) => {
                receive(data);
            });
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // When Ready to Receive Calls
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function onready(subscribed) {
        if (subscribed) myconnection = true;
        if (myconnection && autocam) readycb();
        if (!(mystream && myconnection)) return;

        connectcb();
        if (!autocam) readycb();
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Prepare Local Media Camera and Mic
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function startcamera(source) {
        if (camStarted) return;
        camStarted = true;
        log("startcamera", source);
        navigator.mediaDevices
            .getUserMedia(mediaconf)
            .then((stream) => {
                if (!stream) return unablecb(stream);
                mystream = stream;
                snapshots_setup(stream);
                onready();
                cameracb(myvideo);
                camStarted = true;
                store.dispatch("webrtc/setVideoEnabled", true);
                store.dispatch("webrtc/setMicEnabled", true);
                Object.keys(PHONE.conversations).forEach((id) => {
                    const talk = get_conversation(id);
                    try {
                        talk.pc.getLocalStreams().forEach((x) =>
                            x.getVideoTracks().forEach((track) => {
                                track.enabled = true;
                            })
                        );
                    } catch (e) {
                        console.error("toggleTrack error", e);
                    }
                });
            })
            .catch((info) => {
                log.error("navigator.mediaDevices.getUserMedia(FAIL)", info);
                camStarted = false;
                return unablecb(info);
            });
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Stop Camera/Mic
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function stopcamera() {
        log("stopcamera", mystream);
        if (!mystream) return;
        for (let track of mystream.getTracks()) {
            track.stop();
        }

        store.dispatch("webrtc/setMicEnabled", false);
        Object.keys(PHONE.conversations).forEach((id) => {
            const talk = get_conversation(id);
            try {
                talk.pc.getLocalStreams().forEach((x) =>
                    x.getVideoTracks().forEach((track) => {
                        track.enabled = false;
                    })
                );
            } catch (e) {
                console.error("toggleTrack error", e);
            }
        });
        camStarted = false;
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Toggle Mic
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function toggleAudio() {
        log("toggleAudio", mystream);
        if (!mystream) return;
        let enabled = false;
        for (let track of mystream.getAudioTracks()) {
            track.enabled = !track.enabled;
            enabled = track.enabled;
            store.dispatch("webrtc/setMicEnabled", enabled);
        }
        Object.keys(PHONE.conversations).forEach((id) => {
            const talk = get_conversation(id);
            try {
                talk.pc.getLocalStreams().forEach((x) =>
                    x.getAudioTracks().forEach((track) => {
                        track.enabled = enabled;
                    })
                );
            } catch (e) {
                console.error("toggleTrack error", e);
            }
        });
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Toggle Camera
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function toggleVideo() {
        log("toggleVideo", mystream);
        if (!mystream) return;
        let enabled = false;
        for (let track of mystream.getVideoTracks()) {
            track.enabled = !track.enabled;
            enabled = track.enabled;
            store.dispatch("webrtc/setVideoEnabled", enabled);
        }
        Object.keys(PHONE.conversations).forEach((id) => {
            const talk = get_conversation(id);
            try {
                talk.pc.getLocalStreams().forEach((x) =>
                    x.getVideoTracks().forEach((track) => {
                        track.enabled = enabled;
                    })
                );
            } catch (e) {
                log.error("toggleTrack error", e);
            }
        });
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Initiate Dialing Socket
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function startsubscribe() {
        log("startsubscribe");
        onready();
        dailer_subscribe();
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Send SDP Call Offers/Answers and ICE Candidates to Peer
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function transmit(phone, packet) {
        if (!packet) return;
        let number = myNumber;
        let message = { packet: packet, id: sessionid, number: number };
        debugcb(["transmit(PASS)", message]);
        //pubnub.publish({ channel : phone, message : message });
        sendSocketMessage(socketMessagePrefix + "webrtc", {
            message,
            me: number,
            to: phone,
            siteId: site.state.site._id,
        });
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // SDP Offers & ICE Candidates Receivable Processing
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function receive(message) {
        log("receive", message.packet);

        let talk = get_conversation(message.number);

        // Ignore if Closed
        if (talk.closed) return;
        // if (message.packet.calling){
        //     const agentNumber = message.packet.calling
        //     talk.dial()
        // }

        // User Message
        if (message.packet.usermsg) {
            messagecb(talk, message.packet.usermsg);
            return talk.usermsg(talk, message.packet.usermsg);
        }

        // Thumbnail Preview Image
        if (message.packet.thumbnail) return create_thumbnail(message);

        // If Hangup Request
        if (message.packet.hangup) return talk.hangup(false);

        // If Peer Calling Inbound (Incoming)
        if (message.packet.sdp && !talk.received) {
            if (!talk.received) startcamera("sdp");
            talk.received = true;
            receivercb(talk);
        }

        // Update Peer Connection with SDP Offer or ICE Routes
        if (message.packet.sdp) add_sdp_offer(message);
        else add_ice_route(message);
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Create Remote Friend Thumbnail
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function create_thumbnail(message) {
        let talk = get_conversation(message.number);
        talk.image.src = message.packet.thumbnail;

        // Call only once
        if (!talk.thumb) return;
        if (!talk.imgset) talk.thumb(talk);
        talk.imgset = true;
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Add SDP Offer/Answers
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    async function add_sdp_offer(message) {
        log("add_sdp_offer", message);
        // Get Call Reference
        let talk = get_conversation(message.number);
        let pc = talk.pc;
        let type = message.packet.type == "offer" ? "offer" : "answer";

        // Deduplicate SDP Offerings/Answers
        // if (type in talk) return
        talk[type] = true;
        talk.dialed = true;

        // Notify of Call Status
        update_conversation(talk, "routing");
        if (type === "offer") publishMessage("vc_answered", {});
        // Add SDP Offer/Answer
        pc.setRemoteDescription(new SessionDescription(message.packet))
            .then(() => {
                log("setRemoteDescription success");
                // Set Connected Status
                update_conversation(talk, "connected");

                // Call Online and Ready
                if (pc.remoteDescription.type != "offer") return;

                // Create Answer to Call
                return pc
                    .createAnswer()
                    .then(async (answer) => {
                        log("createAnswer success");
                        pc.setLocalDescription(answer)
                            .then(() => {
                                log("setLocalDescription success");
                                transmit(message.number, answer);
                            })
                            .catch((e) => {
                                log("setLocalDescription error", e);
                            });
                    })
                    .catch((error) => log.error("createAnswer error", error));
            })
            .catch((error) => log.error("setRemoteDescription error", error));
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Add ICE Candidate Routes
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    function add_ice_route(message) {
        // Leave if Non-good ICE Packet
        if (!message.packet) return;
        if (!message.packet.candidate) return;

        // Get Call Reference
        let talk = get_conversation(message.number);
        let pc = talk.pc;

        // Add ICE Candidate Routes
        pc.addIceCandidate(new IceCandidate(message.packet))
            .then((info) => log("addIceCandidate success"))
            .catch((err) => log.error("addIceCandidate error", err));
    }

    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    // Main - Setup Dialer Socket and Camera
    // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
    PHONE.startcamera = () => startcamera("PHONE.startcamera  api");
    PHONE.camera.start = () => startcamera("PHONE.camera.start  api");
    PHONE.camera.stop = stopcamera;
    PHONE.camera.toggleAudio = toggleAudio;
    PHONE.camera.toggleVideo = toggleVideo;
    PHONE.camera.video = () => myvideo;
    PHONE.camera.ready = PHONE.camera;
    PHONE.configUpdate = (config) => {
        mediaconf = config.media;
    };

    // Start Camera Automatically
    if (autocam) startcamera("autocam enabled");

    // Start Dailer Socket
    startsubscribe();

    // Return Phone API
    return PHONE;
});
